import {useEffect, useRef} from 'react'
import Checkbox from '@/components/Form/Checkbox.jsx'
import {subscribe, unsubscribe} from '@/script/event.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'
import cssSettingsItem from '../../SidePanel/LeftPanel/SettingsPane/cssSettingsItem.mjs'

export default function ControllerHideIrrelevant(props) {
    const map = useMapContext()
    const isHidden = map.irrelevant.useIsHidden()
    const refIsToggling = useRef(false)

    const toggleVisibility = async isHidden => {
        refIsToggling.current = true

        await map.execute(() => {
            if (isHidden) {
                map.irrelevant.hide()
            }
            else {
                map.irrelevant.show()
            }
        })

        refIsToggling.current = false
    }

    useEffect(
        () => {
            const handleModelChange = () => {
                if (! refIsToggling.current) {
                    toggleVisibility(isHidden)
                }
            }

            subscribe(map, 'model_change', handleModelChange)

            return () => {
                unsubscribe(map, 'model_change', handleModelChange)
            }
        },

        [isHidden, map, toggleVisibility]
    )

    const handleChange = isChecked => {
        toggleVisibility(isChecked)
    }

    return (
        <Checkbox
            css={cssSettingsItem}
            value={isHidden}
            onChange={handleChange}
            {...props}
        >
            仅历史版本引用链
        </Checkbox>
    )
}
